import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Link } from "react_reusable_components";
import SeeAllNotificationsContainer from "../../containers/SeeAllNotificationsContainer";
import MyNotificationsLayout from "../../layouts/MyNotificationsLayout";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";

export default function SeeAllNotificationsView() {
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <MyNotificationsLayout
      topSection={
        <Link
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
          type="backNavigation"
          href="#"
          iconSrc={"/icons/arrow_back.svg"}
          labelText={getLocalizedMessage(
            intl,
            "notifications.heading.myNotifications"
          )}
        />
      }
      bottomSection={<SeeAllNotificationsContainer />}
    />
  );
}
